import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import Select from "react-select";
import { API_URL } from "../../../../constants";
import { FaSpinner } from "react-icons/fa";

const HolidayCalender = () => {
  const [holidayCalender, setHolidayCalender] = useState([]);
  const [yearOpt, setYearOpt] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Holiday Calender"));
    fetchYearList();
  }, []);

  useEffect(() => {
    if (yearOpt) {
      fetchHolidayCalender(selectedYear?.value);
    }
  }, [yearOpt]);
  const fetchYearList = async () => {
    try {
      let response;

      response = await GetServiceCaller(`${API_URL}holidaymaster-getdata`);

      if (response?.status) {
        const yearOpt = response?.data?.year?.map((o) => ({
          value: o?.value,
          label: o?.text,
        }));

        setYearOpt(yearOpt.reverse());

        const currentYear = new Date().getFullYear();
        const currentYearOption = yearOpt.find((item) =>
          item.label.includes(currentYear.toString())
        );

        if (currentYearOption && !selectedYear) {
          setSelectedYear(currentYearOption);
        }
      }
    } catch (error) {
      console.error("Fetching year  Data Error  ", error);
    }
  };



  const [apiStatus, setApiStatus] = useState('')
  const fetchHolidayCalender = async (year) => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}holidayList?P_CalendarID=${year || ""}`
      );

      if (response?.status === 200) {
        setApiStatus(response?.status)
        const data = response?.data?.data;
        setHolidayCalender(data);
      }
    } catch (error) {
      setApiStatus("")
      console.error("Error fetching holiday calendar:", error);
    }
  };

  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
  };

  const handleGetDataClick = () => {
    if (selectedYear) {
      fetchHolidayCalender(selectedYear.value);
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="holidayCalender">
          <div className="row mb-2">
            <div className="d-flex gap-2">
              <div className="col-md-2">
                <label className="form-label">Year</label>
                <Select
                  options={yearOpt}
                  value={selectedYear}
                  onChange={handleYearChange}
                  isClearable={false}
                />
              </div>
              <div style={{ marginTop: "33px" }}>
                <button className="custom-btn" onClick={handleGetDataClick}>
                  Get Data
                </button>
              </div>
            </div>
          </div>
      <div style={{ overflowX: "auto" }}>
<Table striped bordered hover responsive="md">
  <thead id="thcolor" className="text-center">
    <tr>
      <th style={{ width: '10%' }}>Sr. No.</th>
      <th style={{ width: '40%' }}>Occasion</th>
      <th style={{ width: '25%' }}>Date</th>
      <th style={{ width: '25%' }}>Day</th>
    </tr>
  </thead>
  <tbody className="border-bottom">
    {apiStatus === undefined ? (
      <tr>
        <td colSpan={4} className="text-center">
          <div>
            <p>
              <FaSpinner className="spinner" />
              <br />
              Loading
            </p>
          </div>
        </td>
      </tr>
    ) : holidayCalender?.length === 0 ? (
      <tr>
        <td colSpan="4" className="text-center">No Record</td>
      </tr>
    ) : (
      holidayCalender?.map((holiday, index) => (
        <tr key={index}>
          <td className="text-center" style={{ width: '10%' }}>{index + 1}</td>
          <td style={{ width: '40%' }}>{holiday.Occasion}</td>
          <td className="text-center" style={{ width: '25%' }}>
            {moment(holiday.Date).format("DD MMM YYYY")}
          </td>
          <td style={{ width: '25%' }}>{holiday.DAY}</td>
        </tr>
      ))
    )}
  </tbody>
</Table>

</div>

        </div>
      </div>
    </>
  );
};

export default HolidayCalender;
